import {
    CONFIRM_PAYMENT_START,
    CONFIRM_PAYMENT_SUCCESS,
    CONFIRM_PAYMENT_ERROR
} from '../../constants';
import { setLoaderComplete } from '../loader/loader';
import showToaster from "../../helpers/toastrMessgaes/showToaster"
import { confirmPayment as mutation } from '../../lib/graphql';

export function confirmPaymentAction({ bookingId, paymentIntentId }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: CONFIRM_PAYMENT_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    paymentIntentId,
                },
            });
            if (data?.confirmPayment?.result?.requireAdditionalAction) {
                showToaster({ messageId: 'catchMessage', requestContent: data?.confirmPayment?.errorMessage, toasterType: 'error' });
                setLoaderComplete('paymentLoading');
                dispatch({
                    type: CONFIRM_PAYMENT_ERROR,
                });
            } else {
                dispatch(setLoaderComplete('paymentLoading'))
                dispatch({
                    type: CONFIRM_PAYMENT_SUCCESS,
                });
            }
        } catch (error) {
            dispatch({
                type: CONFIRM_PAYMENT_ERROR,
            });
            dispatch(setLoaderComplete('paymentLoading'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}